import { BillingApi, Configuration } from '@/api';
import { invoicesQueryKey } from '@/api/queries/useFindInvoicesQuery';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export default function useGenerateInvoicesMutation() {
  const queryClient = useQueryClient();
  const auth = useAuth();
  const api = new BillingApi(new Configuration(auth));

  return useMutation({
    mutationFn: async () => {
      return api.generateInvoices();
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === invoicesQueryKey[0],
      });
    },
  });
}
